import { UseScrollEndEffectProps } from "@ctypes";
import { useEffect } from "react";

const DEBOUNCE_DELAY = 200;

export const useScrollEndEffect = ({ fetchMore }: UseScrollEndEffectProps) => {
  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const handleScroll = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      timeoutId = setTimeout(() => {
        if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 5) {
          fetchMore();
        }
      }, DEBOUNCE_DELAY);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutId);
    };
  }, [fetchMore]);
};
